import { requiredValidator, optionalValidator } from '@cvent/nucleus-form-validations';
import plainTextFromDangerouslySetInnerHtml from 'nucleus-widgets/utils/plainTextFromDangerouslySetInnerHtml';

/**
 * Validates if a string is a currency value i.e. if it is a non-negative decimal
 */
export const currencyValidatorWithZero = (value) => {
  // allow 0
  // Check for digits followed by an optional group of a decimal followed by  0 - 2 numbers
  const currencyFormat = /^[0-9]\d*((\.\d{0,2})?)$/;
  return requiredValidator(value) && currencyFormat.test(value);
};

export const textCurrencyWithZero = (translate) => ({
  validator: optionalValidator(currencyValidatorWithZero),
  errorMessage(value, field) {
    return translate('NucleusWidgets_Validations_CurrencyFormat__resx',
      { field: plainTextFromDangerouslySetInnerHtml(field) });
  }
});

// this validator does not invalidate NaN so it must be handled in another validator
export const decimalValidator = (min, max) => (value) => {
  if (!requiredValidator(value)) {
    return false;
  }
  const numValue = Number(value.trim());
  return isNaN(numValue) ||
    ((typeof min !== 'number' || numValue >= min) &&
    (typeof max !== 'number' || numValue <= max));
};

export const textDecimalInRange = (translate, min, max) => ({
  validator: optionalValidator(decimalValidator(min, max)),
  errorMessage(value, field) {
    let message;
    if (typeof min === 'number' && typeof max === 'number') {
      message = 'NucleusWidgets_Validations_NumberFormatFieldBetween__resx';
    } else if (typeof min === 'number') {
      message = 'NucleusWidgets_Validations_NumberFormatFieldGreaterThan__resx';
    } else if (typeof max === 'number') {
      message = 'EventWidgets_Validations_NumberFormatFieldLessThan__resx';
    } else {
      message = 'NucleusWidgets_Validations_NumberFormatFieldAny__resx';
    }
    return translate(message, {
      field: plainTextFromDangerouslySetInnerHtml(field),
      min: typeof min === 'number' ? min.toString() : min,
      max: typeof max === 'number' ? max.toString() : max
    });
  }
});
